<template>
  <div class="loader">
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__ball"></div>
  </div>
</template>

<style lang="scss" scoped>
// Variables
$bar-color: #ea4961;
$ball-color: #ea4961;
$bg-color: #fff;

html {
  height: 100%;
}
body {
  height: 100%;
  background: $bg-color;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader {
  position: relative;
  width: 38px;
  height: 50px;

  &__bar {
    position: absolute;
    bottom: 0;
    width: 5px;
    height: 50%;
    background: $bar-color;
    transform-origin: center bottom;
    box-shadow: 1px 1px 0 rgba(0, 0, 0, 0.2);

    @for $i from 1 through 5 {
      &:nth-child(#{$i}) {
        left: ($i - 1) * 8px;
        transform: scale(1, $i * 0.2);
        animation: barUp#{$i} 4s infinite;
      }
    }
  }

  &__ball {
    position: absolute;
    bottom: 5px;
    left: 0;
    width: 5px;
    height: 5px;
    background: $ball-color;
    border-radius: 50%;
    animation: ball 4s infinite;
  }
}

@keyframes ball {
  0% {
    transform: translate(0, 0);
  }
  5% {
    transform: translate(4px, -7px);
  }
  10% {
    transform: translate(8px, -5px);
  }
  17% {
    transform: translate(12px, -12px);
  }
  20% {
    transform: translate(16px, -10px);
  }
  27% {
    transform: translate(20px, -17px);
  }
  30% {
    transform: translate(24px, -15px);
  }
  37% {
    transform: translate(28px, -22px);
  }
  40% {
    transform: translate(32px, -20px);
  }
  50% {
    transform: translate(32px, 0);
  }
  57% {
    transform: translate(28px, -7px);
  }
  60% {
    transform: translate(24px, -5px);
  }
  67% {
    transform: translate(20px, -12px);
  }
  70% {
    transform: translate(16px, -10px);
  }
  77% {
    transform: translate(12px, -17px);
  }
  80% {
    transform: translate(8px, -15px);
  }
  87% {
    transform: translate(4px, -22px);
  }
  90% {
    transform: translate(0, -20px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes barUp1 {
  0% {
    transform: scale(1, 0.2);
  }
  40% {
    transform: scale(1, 0.2);
  }
  50% {
    transform: scale(1, 1);
  }
  90% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 0.2);
  }
}
@keyframes barUp2 {
  0% {
    transform: scale(1, 0.4);
  }
  40% {
    transform: scale(1, 0.4);
  }
  50% {
    transform: scale(1, 0.8);
  }
  90% {
    transform: scale(1, 0.8);
  }
  100% {
    transform: scale(1, 0.4);
  }
}
@keyframes barUp3 {
  0% {
    transform: scale(1, 0.6);
  }
  100% {
    transform: scale(1, 0.6);
  }
}
@keyframes barUp4 {
  0% {
    transform: scale(1, 0.8);
  }
  40% {
    transform: scale(1, 0.8);
  }
  50% {
    transform: scale(1, 0.4);
  }
  90% {
    transform: scale(1, 0.4);
  }
  100% {
    transform: scale(1, 0.8);
  }
}
@keyframes barUp5 {
  0% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1, 0.2);
  }
  90% {
    transform: scale(1, 0.2);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
